import { ComponentType } from 'react';

import AmountField from 'modules/common/components/MUI/AmountField';
import CheckboxButtonGroup from 'modules/common/components/CheckboxButtonGroup';
import DateField from 'modules/common/components/MUI/DateField/DateField';
import RadioButtonGroup from 'modules/common/components/RadioButtonGroup';
import Select from 'modules/common/components/MUI/Select';
import TextField from 'modules/common/components/MUI/TextField';
import { FieldType, FieldTypes, FormField } from 'modules/Tasks/types';

// ---- Interfaces ----

interface FieldComponentProps {
    field: FormField;
}

// ---- Components ----

function FormFieldText({ field }: Readonly<FieldComponentProps>) {
    return <TextField name={field.key} fullWidth placeholder="Enter text here..." />;
}

function FormFieldTextarea({ field }: Readonly<FieldComponentProps>) {
    return <TextField name={field.key} fullWidth multiline rows={4} placeholder="Enter text here..." />;
}

function FormFieldNumber({ field }: Readonly<FieldComponentProps>) {
    return <TextField name={field.key} type="number" placeholder="Enter a number" sx={{ width: 200 }} />;
}

function FormFieldCurrency({ field }: Readonly<FieldComponentProps>) {
    return (
        <AmountField name={field.key} placeholder="$0.00" inputComponentProps={{ prefix: '$' }} sx={{ width: 200 }} />
    );
}

function FormFieldDate({ field }: Readonly<FieldComponentProps>) {
    return <DateField name={field.key} TextFieldProps={{ sx: { width: 200 } }} />;
}

function FormFieldDropdown({ field }: Readonly<FieldComponentProps>) {
    const options = (field.options ?? []).map((opt) => ({ value: opt, label: opt }));
    return <Select name={field.key} label="" options={options} placeholder="Select an option" fullWidth />;
}

function FormFieldSelect({ field }: Readonly<FieldComponentProps>) {
    const options = (field.options ?? []).map((opt) => ({ value: opt, label: opt }));
    return <RadioButtonGroup name={field.key} options={options} direction="column" />;
}

function FormFieldMultiselect({ field }: Readonly<FieldComponentProps>) {
    const options = (field.options ?? []).map((opt) => ({ value: opt, label: opt }));
    return <CheckboxButtonGroup name={field.key} options={options} direction="column" />;
}

// ---- Dispatch map ----

const FIELD_COMPONENT_BY_TYPE: Record<FieldType, ComponentType<FieldComponentProps>> = {
    [FieldTypes.TEXT]: FormFieldText,
    [FieldTypes.TEXTAREA]: FormFieldTextarea,
    [FieldTypes.NUMBER]: FormFieldNumber,
    [FieldTypes.CURRENCY]: FormFieldCurrency,
    [FieldTypes.DATE]: FormFieldDate,
    [FieldTypes.DROPDOWN]: FormFieldDropdown,
    [FieldTypes.SELECT]: FormFieldSelect,
    [FieldTypes.MULTISELECT]: FormFieldMultiselect,
};

export default FIELD_COMPONENT_BY_TYPE;
